import React from 'react'
import { useState, useEffect } from 'react'
import '../sass/layout.sass'
import { Outlet, NavLink, useNavigate, useLocation, useParams  } from "react-router-dom"
import { translatePath } from '../utils/i18n/translateUrls'
import { useTranslation } from 'react-i18next'
import menu from '../img/menu.svg'
import logo from '../img/logo_tanja.svg'
import closeBtn from '../img/close.svg'

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { lng } = useParams();
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false)

    const toggleMenu = () => {
        setIsOpen((open) => !open);
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    const changeLanguage = (lng) => {
        const currentLang = i18n.language;
        const newPath = translatePath(location.pathname, currentLang, lng);

        i18n.changeLanguage(lng);
        closeMenu();
        navigate(newPath);
    };

    useEffect(() => {
        if (lng && i18n.language !== lng) {
        i18n.changeLanguage(lng);
        }
    }, [lng, i18n]);

    return (
        <>
            <header className='header container-fluid'>
                <nav className='container navBar'>
                    <NavLink className="logo" to={`/${lng}`}>
                        <img className='logoImg' src={logo} alt="Logo" />
                    </NavLink>
                    <ul className={`mainMenu ${isOpen ? "isOpen" : ""}`}>
                        <li className={isOpen ? "closeBtn" : "hideCloseBtn"} onClick={closeMenu}>
                            <img src={closeBtn} alt="close-button" />
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}`} onClick={closeMenu} end>{t("Home")}</NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}/${t("about")}`} onClick={closeMenu}>{t("About")}</NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}/${t("contact")}`} onClick={closeMenu}>{t("Contact")}</NavLink>
                        </li>
                        <li>
                            <button className={`langBtn ${i18n.language === "hr" ? "active" : ""}`} type="button" onClick={() => changeLanguage('hr')}>hr</button>
                            <span className='langTxt'>{t("Croatian")}</span>
                        </li>
                        <li>
                            <button className={`langBtn ${i18n.language === "en" ? "active" : ""}`} type="button" onClick={() => changeLanguage('en')}>en</button>
                            <span className='langTxt'>{t("English")}</span>
                        </li>
                    </ul>
                    <img className='hamburgerMenu' src={menu} alt="menu-icon" onClick={toggleMenu} />
                </nav>
            </header>

            <Outlet />

            <footer className='footer'>
                <div className='container text-center d-grid'>
                    <NavLink className="logo" to={`/${lng}`}>
                        <img className='logoImg' src={logo} alt="Logo" />
                    </NavLink>
                    <ul className='mainMenuFooter'>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}`} onClick={closeMenu} end>{t("Home")}</NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}/${t("about")}`} onClick={closeMenu}>{t("About")}</NavLink>
                        </li>
                        <li>
                            <NavLink className={({ isActive }) => isActive ? "active" : "" } to={`/${lng}/${t("contact")}`} onClick={closeMenu}>{t("Contact")}</NavLink>
                        </li>
                    </ul>
                    <div className='hr my-10 mb-20'></div>
                    <p className="font-sm">{t("developedBy")}</p>
                </div>
            </footer>
        </>
    )
};

export default Layout;